import React, { useState } from "react";
import { Modal, Input, DatePicker, TimePicker, Radio, Button } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./remaindermodal.css";
import { message } from "antd";

const RemainderModal = ({ visible, onClose }) => {
  const [recipient, setRecipient] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [alert, setAlert] = useState("none");

  const handleSubmit = () => {
    const formData = {
      recipient,
      title,
      description,
      date,
      time,
      alert,
    };

    console.log("Form Data:", formData);

    message.open({
      type: "success",
      content: "Remainder sent successfully!",
      duration: 3,
      className: "custom-success-message",
    });

    onClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={700}
      className="remainder-modal"
    >
      <h2 className="modal-title">Remainder</h2>

      <div className="form-group">
        <label>Recipient</label>
        <Input
          placeholder="Enter Title"
          value={recipient}
          onChange={(e) => setRecipient(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>Enter Title</label>
        <Input
          placeholder="Enter Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>Description</label>

        <div className="custom-quill-wrapper">
          <ReactQuill
            theme="snow"
            value={description}
            onChange={setDescription}
            placeholder="Write here.."
            modules={{
              toolbar: [
                [{ font: [] }], // First dropdown — Font picker ("Inter")
                [{ header: [1, 2, 3, false] }], // Second dropdown — Header picker ("Paragraph")
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                ["link"],
              ],
            }}
            formats={[
              "font",
              "header",
              "bold",
              "italic",
              "underline",
              "strike",
              "list",
              "bullet",
              "align",
              "link",
            ]}
          />
        </div>
      </div>

      <div className="date-time-grid">
        <div className="grid-item">
          <label>Date</label>
          <DatePicker
            value={date}
            onChange={(value) => setDate(value)}
            style={{ width: "100%" }}
          />
        </div>

        <div className="grid-item">
          <label>Time</label>
          <TimePicker
            value={time}
            onChange={(value) => setTime(value)}
            format="hh:mm A"
            use12Hours
            style={{ width: "100%" }}
          />
        </div>

        <div className="grid-item alert-group">
          <label>Alert</label>
          <div className="d-flex  raido-button-section">
            <Radio.Group
              value={alert}
              onChange={(e) => setAlert(e.target.value)}
            >
              <Radio value="none">None</Radio>
              <Radio value="6hr">6 Hours</Radio>
              <Radio value="24hr">24 Hours</Radio>
            </Radio.Group>
          </div>
        </div>
      </div>
      

      <div className="text-end mt-3">
        <Button type="primary" onClick={handleSubmit}> Sent </Button>
      </div>


    </Modal>
  );
};

export default RemainderModal;
